// @ts-check

import { onDomReady } from '../utils/dom';

/**
 * @param {import('../vendor/fslightbox-pro/index').FsLightbox} FsLightbox
 */
function setFsLightboxOptions({ props, elements }) {
    // By default lightbox won't exit fullscreen on close.
    props.exitFullscreenOnClose = true;

    // By default lightbox at open loads 3 stage sources (previous, current, next).
    props.loadOnlyCurrentSource = false;

    // Lightbox cannot detect max sizes of YouTube videos.
    props.maxYoutubeDimensions = { width: 1920, height: 1080 };

    // Time for changing slides in slideshow (in milliseconds)
    props.slideshowTime = 8000;

    // Time after UI fades out (in milliseconds)
    props.UIFadeOutTime = 8000;

    // A value that increases the scale on click zoom
    props.zoomIncrement = 0.25;

    // To show thumbs at lightbox open
    if (elements.a.length > 1) {
        props.showThumbsOnMount = true;
    }
}

function initFslightbox() {
    /** @type {NodeListOf<HTMLAnchorElement>} */
    const lightboxes = document.querySelectorAll('a[data-lightbox]:not([target="_blank"])');

    if (!lightboxes.length) {
        return;
    }

    const w = /** @type {import('../vendor/fslightbox-pro/index').window} */ (window);

    import('../vendor/fslightbox-pro/fslightbox-v3.6.2').then(() => {
        lightboxes.forEach((lightbox) => {
            lightbox.dataset.fslightbox =
                lightbox.dataset.lightbox === '' ? Math.random().toString(36).slice(2, 7) : lightbox.dataset.lightbox;

            if (lightbox.nextElementSibling?.nodeName === 'FIGCAPTION') {
                lightbox.dataset.caption = lightbox.nextElementSibling.textContent ?? '';
            }
        });

        w.refreshFsLightbox();

        for (const [, FsLightbox] of Object.entries(w.fsLightboxInstances)) {
            setFsLightboxOptions(FsLightbox);
        }
    });
}

onDomReady(() => {
    initFslightbox();
});
